import React, { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { Form, InputGroup, Modal } from "react-bootstrap";
import ReactSelect from "react-select";
import Select from "react-select/creatable";
import { BsTrashFill } from "react-icons/bs";

import { ModalContext } from "../../context/modal";
import { authApi, noAuth } from "../../services/api";
import { TOASTIFY_OPTIONS } from "../../style/global";
import { DefaultButton, MyModalBody, MyModalInput } from "../../style/default";
import {
	DivisionBox,
	DivisionTemplateType,
	MyModalTextArea,
	QuickyReplies,
	QuickyRepliesAction,
} from "./styles";
import { customStyles } from "../../style/selectStyles";
import { Loading } from "../../components/Loading";

const regexVars = new RegExp(`{{([^}]*)}}`, "gm");

const quickyRepliesActions = [
	{ value: "keep_chat", label: "Seguir conversa" },
	{ value: "ignore-answer", label: "Ignorar resposta" },
];

const categories = [
	{ value: "PAYMENT_UPDATE", label: "PAYMENT_UPDATE" },
	{ value: "ACCOUNT_UPDATE", label: "ACCOUNT_UPDATE" },
	{ value: "PERSONAL_FINANCE_UPDATE", label: "PERSONAL_FINANCE_UPDATE" },
	{ value: "SHIPPING_UPDATE", label: "SHIPPING_UPDATE" },
	{ value: "RESERVATION_UPDATE", label: "RESERVATION_UPDATE" },
	{ value: "ISSUE_RESOLUTION", label: "ISSUE_RESOLUTION" },
	{ value: "APPOINTMENT_UPDATE", label: "APPOINTMENT_UPDATE" },
	{ value: "TRANSPORTATION_UPDATE", label: "TRANSPORTATION_UPDATE" },
	{ value: "TICKET_UPDATE", label: "TICKET_UPDATE" },
	{ value: "ALERT_UPDATE", label: "ALERT_UPDATE" },
	{ value: "AUTO_REPLY", label: "AUTO_REPLY" },
	{ value: "TRANSACTIONAL", label: "TRANSACTIONAL" },
	{ value: "MARKETING", label: "MARKETING" },
	{ value: "OTP", label: "OTP" },
];

const templateTypesOptions = [
	{
		label: "Contato",
		value: "contact",
	},
	{
		label: "Workflow",
		value: "workflow",
	},
];

const headerOptions = [
	{
		label: "Texto",
		value: "text",
	},
	{
		label: "Imagem",
		value: "image",
	},
	{
		label: "Vídeo",
		value: "video",
	},
	{
		label: "Documento",
		value: "document",
	},
];

const buttonTemplateTypes = [
	{
		label: "Resposta rápida",
		value: "quicky_reply",
	},
	{
		label: "Call to action",
		value: "call_to_action",
	},
];

const callToActionButtonTypes = [
	{
		label: "URL",
		value: "url",
	},
	{
		label: "Número de telefone",
		value: "phone_number",
	},
];

const defaultQuickReplyAction = {
	value: "keep_chat",
	label: "Seguir conversa",
};

const callToActionButton = {
	label: callToActionButtonTypes[0].label,
	value: callToActionButtonTypes[0].value,
};

const confirmAPIRegistration =
	"Deseja realmente cadastrar este template na API?";

function ModalCheckTemplateEdit({
	open,
	data,
	selectedAccount,
	selectedStatus,
	populateTable,
}) {
	const variables = useRef([]);
	const variablesWithValue = useRef([]);
	const headerFileRef = useRef();

	const { handleOpenModal } = useContext(ModalContext);

	const [isLoading, setIsLoading] = useState(false);
	const [name, setName] = useState("");
	const [gupshupElementName, setGupshupElementName] = useState("");
	const [content, setContent] = useState("");
	const [category, setCategory] = useState({ value: "", label: "" });
	const [selectTemplateType, setSelectTemplateType] = useState([]);
	const [templateVariables, setTemplateVariables] = useState([]);
	const [templateExamples, setTemplateExamples] = useState([]);
	const [valueVariable, setValueVariable] = useState({});
	const [hubspotProperties, setHubspotProperties] = useState([]);
	const [selectedQuickyReplies, setSelectedQuickyReplies] = useState([]);
	const [headerType, setHeaderType] = useState({
		label: headerOptions[0].label,
		value: headerOptions[0].value,
	});
	const [headerContent, setHeaderContent] = useState("");
	const [fileSelected, setFileSelected] = useState(null);
	const [selectTemplateButton, setSelectTemplateButton] = useState({
		label: buttonTemplateTypes[0].label,
		value: buttonTemplateTypes[0].value,
	});
	const [footerContent, setFooterContent] = useState("");

	const handleHubspotProperties = async ({ portalId }) => {
		try {
			const { data } = await noAuth.post("/workflow/getProperties", {
				origin: {
					portalId,
				},
			});
			setHubspotProperties(data.options);
		} catch (err) {
			console.log(err);
		}
	};

	useEffect(() => {
		if (data) {
			const hasVariables = data.variablesWithProperties;
			if (hasVariables) {
				if (Object.keys(hasVariables)[0]) {
					const nameValueVariable = Object.entries(hasVariables).map(
						([key, value]) => ({ key, value })
					);
					variablesWithValue.current = nameValueVariable;
				}
			}
			handleHubspotProperties({ portalId: data.portalId });
			setName(data?.name);
			setContent(data?.content);
			setGupshupElementName(data?.gupshupElementName || "");
			setCategory({ label: data?.category, value: data?.category });
			setSelectedQuickyReplies(data?.quickyReplies);

			setSelectTemplateType(
				templateTypesOptions.filter((tmp) =>
					data.type.some((tt) => tt === tmp.value)
				)
			);

			const headerOptionFounded =
				headerOptions.find((opt) => opt.value === data.headerType) ||
				headerOptions[0];
			setHeaderType(headerOptionFounded);
			const buttonType =
				buttonTemplateTypes.find(
					(btnType) =>
						data.quickyReplies.length &&
						btnType.value === data.quickyReplies[0].buttonType
				) || selectTemplateButton;
			setSelectTemplateButton(buttonType);
			setFooterContent(data?.footer || "");
			setHeaderContent(data?.headerContent || "");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data]);

	useEffect(() => {
		let result;
		variables.current = [];
		while ((result = regexVars.exec(content))) {
			const key = result[0].split(new RegExp(`{{([^}]*)}}`, "gm"))[1];
			const foundValueVariable = variablesWithValue.current.find(
				(vari) => vari.key === key
			);
			variables.current.push({
				key,
				value: foundValueVariable ? foundValueVariable.value : null,
			});

			handleValue(foundValueVariable);
			setTemplateVariables(variables.current);
		}
		if (!variables.current.length) {
			setTemplateVariables([]);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [content]);

	const handleAPIRegistration = async () => {
		const confirm = window.confirm(confirmAPIRegistration);

		if (!confirm) return;
		setIsLoading(true);

		const variablesAsObj = {};
		templateVariables.forEach((tmp) => {
			variablesAsObj[tmp.key.replaceAll(".", "_")] = tmp.value ?? "";
		});
		const exaplesAsObj = {};
		templateExamples.forEach((tmp) => {
			exaplesAsObj[tmp.key.replaceAll(".", "_")] = tmp.value ?? "";
		});

		const formData = {
			name: name,
			gupshupElementName: gupshupElementName,
			content: content,
			category: category.value,
			quickyReplies: selectedQuickyReplies,
			variablesWithProperties: variablesAsObj,
			type: selectTemplateType.map(({ value }) => value),
			headerContent: headerContent,
			headerType: headerType.value,
			selectTemplateButton: selectTemplateButton.value,
			footer: footerContent,
			templateExamples: exaplesAsObj,
			accountId: data?.accountId,
		};

		try {
			await authApi.post(`/template/api/${data?._id}`, formData);
			populateTable(selectedAccount.value, selectedStatus.value);
			handleOpenModal();
			toast.success("Template editado com sucesso.", TOASTIFY_OPTIONS);
		} catch (error) {
			handleOpenModal();
		} finally {
			setIsLoading(false);
		}
	};

	const handleTemplateEdit = async () => {
		const variablesAsObj = {};
		templateVariables.forEach((tmp) => {
			variablesAsObj[tmp.key.replaceAll(".", "_")] = tmp.value ?? "";
		});

		if (selectedQuickyReplies.length) {
			if (selectedQuickyReplies.some((reply) => reply.value.length > 20)) {
				toast.error(
					"A resposta rápida deve ter até 20 caracteres!",
					TOASTIFY_OPTIONS
				);
				return;
			}
			if (selectedQuickyReplies.some((reply) => !reply.value)) {
				toast.error(
					"A resposta rápida deve ter até 20 caracteres!",
					TOASTIFY_OPTIONS
				);
				return;
			}
			if (!selectTemplateType.length) {
				toast.error(
					"O template tem que ter pelo menos 1 tipo selecionado!",
					TOASTIFY_OPTIONS
				);
				return;
			}
		}

		const formData = new FormData();
		formData.append("name", name);
		formData.append("gupshupElementName", gupshupElementName);
		formData.append("content", content);
		formData.append("category", category.value);
		formData.append("quickyReplies", JSON.stringify(selectedQuickyReplies));
		formData.append("variablesWithProperties", JSON.stringify(variablesAsObj));
		formData.append(
			"type",
			JSON.stringify(selectTemplateType.map(({ value }) => value))
		);
		if (fileSelected) {
			formData.append("templateFileHeader", fileSelected);
		}
		formData.append("headerContent", headerContent);
		formData.append("headerType", headerType.value);
		formData.append("selectTemplateButton", selectTemplateButton.value);
		formData.append("footer", footerContent);
		formData.append("accountId", data?.accountId);

		try {
			await authApi.post(`/template/edit/${data?._id}`, formData);
			populateTable(selectedAccount.value, selectedStatus.value);
			handleOpenModal();
			toast.success("Template editado com sucesso.", TOASTIFY_OPTIONS);
		} catch (error) {
			toast.error(error.message, TOASTIFY_OPTIONS);
			handleOpenModal();
		}
	};

	const handleVariables = (variable) => {
		return (e) => {
			for (let i = 0; i < templateVariables.length; i++) {
				if (templateVariables[i].key === variable.key) {
					templateVariables[i].value = e.value;
				}
			}
			handleValue(e);
			setTemplateVariables(templateVariables);
		};
	};

	const handleExamples = (variable) => {
		return (e) => {
			const a = templateExamples;

			for (let i = 0; i < templateVariables.length; i++) {
				if (templateVariables[i].key === variable.key) {
					a[i] = { value: e.target.value, key: variable.key };
				}
			}
			setTemplateExamples(a);
		};
	};

	const addNewQuickyReply = () => {
		const CALL_TO_ACTION = "call_to_action";

		if (
			selectedQuickyReplies.some((quickyReply) => !quickyReply.value.length)
		) {
			return;
		}

		if (selectTemplateButton.value === CALL_TO_ACTION) {
			if (
				selectedQuickyReplies.some(
					(quickyReply) =>
						!quickyReply.value.length || !quickyReply.actionContent.length
				)
			) {
				return;
			}
		}

		if (selectTemplateButton.value === CALL_TO_ACTION) {
			if (selectedQuickyReplies.length + 1 > 2) {
				return;
			}
		}

		if (selectedQuickyReplies.length + 1 > 3) {
			return;
		}
		setSelectedQuickyReplies([
			...selectedQuickyReplies,
			{
				value: "",
				action: "keep_chat",
				buttonType: selectTemplateButton.value, // quicky_reply or media_interactive
				actionContent: "",
				typeAction: callToActionButton.value, //url or phone_number
			},
		]);
	};

	const removeQuickyReply = (index) => {
		return () => {
			const foundedQuickReply = selectedQuickyReplies.filter(
				(_, idx) => index !== idx
			);
			setSelectedQuickyReplies(foundedQuickReply);
		};
	};

	function setQuikcyReplyValue(i, field, value) {
		const scheduleItemModified = selectedQuickyReplies.map(
			(quickyReply, index) => {
				if (index === i) {
					return {
						...quickyReply,
						[field]: value,
					};
				}
				return quickyReply;
			}
		);

		setSelectedQuickyReplies(scheduleItemModified);
	}

	const handleValue = (variable) => {
		const defaultValue = {
			label: "Nenhum",
			value: "",
		};
		setValueVariable(
			variable
				? hubspotProperties.find(
						(hsProps) => hsProps.value === variable.value
				  ) ?? defaultValue
				: defaultValue
		);
	};

	function handleInputFileClick() {
		if (headerFileRef.current) {
			headerFileRef.current.click();
		}
	}

	function handleFileSelected(e) {
		const [file] = e.target.files;

		const mimeTypesAccepted =
			{
				image: ["image/png", "image/jpeg", "image/jpg", "image/webp"],
				video: ["video/webm", "video/ogg", "video/mp4"],
				document: ["application/pdf"],
			}[headerType.value] || false;

		if (!mimeTypesAccepted) {
			return;
		}

		if (file) {
			if (!mimeTypesAccepted.some((type) => file.type.includes(type))) {
				toast.error("Tipo de arquivo não suportado para o tipo de cabeçalho.", {
					...TOASTIFY_OPTIONS,
					autoClose: 1000 * 10,
				});
				return;
			}
		}

		setFileSelected(file);
	}

	return (
		<Modal show={open} onHide={handleOpenModal} size="lg" backdrop="static">
			{isLoading ? <Loading /> : null}
			<Modal.Header closeLabel="" closeButton>
				<Modal.Title>Edição do template: {data?.name}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<MyModalBody>
					<label>Nome do template</label>
					<MyModalInput
						type="text"
						placeholder="Ex: Boas vindas"
						onChange={(e) => setName(e.target.value)}
						value={name}
					/>
					<label>Element name</label>
					<MyModalInput
						type="text"
						placeholder="Ex: template_boas_vindas"
						onChange={(e) => setGupshupElementName(e.target.value)}
						value={gupshupElementName}
					/>
					<label>Conteúdo do template</label>
					<MyModalTextArea
						placeholder="Ex: Olá, {{contato}}. Seja muito bem-vindo a nosso canal do whatsapp ."
						onChange={(e) => setContent(e.target.value)}
						value={content}
					/>
					{templateVariables.map((variable) => (
						<>
							<label key={variable}>
								Nome da propriedade assossiada à variavel (apenas CRM Hubspot)
								<strong> {variable.key}</strong>
							</label>
							<Select
								placeholder="Ex: First Name ou vazio"
								onChange={handleVariables(variable)}
								options={[{ label: "Nenhum", value: "" }, ...hubspotProperties]}
								styles={customStyles}
								defaultValue={
									hubspotProperties.find((a) => a.value === variable.value) ||
									undefined
								}
							/>
							<label key={variable}>
								Valor de exemplo da propriedade assossiada à variavel
								<strong> {variable.key}</strong>
							</label>
							<MyModalInput
								type="text"
								placeholder="Ex: João; São Paulo; R$100,00"
								onChange={handleExamples(variable)}
							/>
							{!data?.registerByAPI ? <></> : null}
						</>
					))}

					{templateVariables.length ? <hr /> : null}
					<label htmlFor="">Categoria</label>
					<ReactSelect
						placeholder="Digite até 3 respostas rápidas e aperte enter ao terminar"
						options={categories}
						onChange={(e) => setCategory(e)}
						value={category}
						noOptionsMessage={() => ""}
						styles={customStyles}
					/>
					<label htmlFor="">Selecione o tipo do template</label>
					<Select
						placeholder="Ex: Workflow"
						styles={customStyles}
						isMulti
						options={templateTypesOptions}
						onChange={(e) => {
							setSelectTemplateType(e);
						}}
						value={selectTemplateType}
					/>

					<DivisionTemplateType className="template-header">
						<div>
							<span>Cabeçalho</span>
							<Select
								placeholder={`Ex: ${headerOptions[0].label}`}
								styles={customStyles}
								options={headerOptions}
								onChange={(e) => setHeaderType(e)}
								value={headerType}
								noOptionsMessage={() => "Nenhum resultado encontrado."}
							/>
						</div>
						<hr />
						{headerType.value === "text" ? (
							<>
								<Form.Label>Conteúdo do cabeçalho</Form.Label>
								<Form.Control
									as="textarea"
									type="text"
									rows={4}
									placeholder="Ex: Esta é uma mensagem automátca."
									onChange={(e) => setHeaderContent(e.target.value)}
									value={headerContent}
								/>
							</>
						) : (
							<>
								<DefaultButton type="button" onClick={handleInputFileClick}>
									Selecione o arquivo para upload
								</DefaultButton>
								<input
									type="file"
									style={{ display: "none" }}
									ref={headerFileRef}
									onChange={handleFileSelected}
								/>
								<span className="template-header--obs">
									Você pode selecionar outro arquivo apenas clicando novamente
									no botão acima.
								</span>
								{fileSelected ? (
									<span className="template-header--filename">
										Arquivo selecionado: {fileSelected.name}
									</span>
								) : null}
							</>
						)}
					</DivisionTemplateType>

					<DivisionTemplateType className="template-buttons">
						<div>
							<span>Respostas rápidas</span>
							<Select
								styles={customStyles}
								placeholder={`Ex: ${buttonTemplateTypes[0].label}`}
								noOptionsMessage={() => "Nenhum resultado encontrado"}
								options={buttonTemplateTypes}
								onChange={(e) => {
									setSelectTemplateButton(e);
								}}
								value={selectTemplateButton}
							/>
							<DefaultButton
								type="button"
								style={{ fontSize: "13px", marginLeft: "auto" }}
								onClick={addNewQuickyReply}
							>
								Adicionar resposta rápida
							</DefaultButton>
						</div>
						<hr />
						{selectedQuickyReplies.map((quickyReply, index) => (
							<InputGroup key={index} className="quicky_replies_types">
								<DefaultButton
									type="button"
									title="Remover resposta rápida"
									className="remove-quicky-reply"
									onClick={removeQuickyReply(index)}
								>
									<BsTrashFill />
								</DefaultButton>
								<QuickyReplies>
									{selectTemplateButton.value === "call_to_action" ? (
										<DivisionBox className="btn-call-to-action">
											<InputGroup>
												<label htmlFor="">
													Selecione um tipo de interação para o botão
												</label>
												<Select
													styles={customStyles}
													placeholder={`Ex: ${callToActionButtonTypes[0].label}`}
													noOptionsMessage={() => "Nenhum resultado encontrado"}
													options={callToActionButtonTypes}
													onChange={(e) => {
														setQuikcyReplyValue(index, "typeAction", e.value);
													}}
													value={callToActionButtonTypes.find(
														(action) => action.value === quickyReply.typeAction
													)}
												/>
											</InputGroup>
											<label htmlFor="">
												{
													callToActionButtonTypes.find(
														(action) => action.value === quickyReply.typeAction
													).label
												}
											</label>
											<Form.Control
												placeholder="Digite o valor correspondente da seleção acima"
												value={quickyReply.actionContent}
												onChange={(e) => {
													setQuikcyReplyValue(
														index,
														"actionContent",
														e.target.value
													);
												}}
												name="quicky-reply"
											/>
										</DivisionBox>
									) : null}

									<Form.Label style={{ margin: "10px 0 0 0" }}>
										Conteúdo da resposta
									</Form.Label>

									<InputGroup style={{ margin: "10px 0" }}>
										<Form.Control
											placeholder="Ex: Me ligue."
											value={quickyReply.value}
											name="quicky-reply"
											onChange={(e) => {
												if (e.target.value.length > 20) return;
												setQuikcyReplyValue(index, "value", e.target.value);
											}}
											onKeyDown={(e) => {
												if (e.key === "Enter") {
													addNewQuickyReply();
												}
											}}
										/>
									</InputGroup>
								</QuickyReplies>

								<QuickyRepliesAction>
									<label htmlFor="">Ação:</label>
									<Select
										styles={customStyles}
										placeholder="Ex: Seguir conversa"
										noOptionsMessage={() => "Nenhum resultado encontrado"}
										options={quickyRepliesActions}
										onChange={(e) => {
											setQuikcyReplyValue(index, "action", e.value);
										}}
										value={
											quickyRepliesActions.find(
												(reply) => reply.value === quickyReply.action
											) || defaultQuickReplyAction
										}
									/>
								</QuickyRepliesAction>
								<hr />
							</InputGroup>
						))}
					</DivisionTemplateType>

					<DivisionTemplateType className="template-footer">
						<div>
							<span>Rodapé do template</span>
						</div>
						<hr />
						<Form.Label>Conteúdo do rodapé</Form.Label>
						<Form.Control
							as="textarea"
							type="text"
							rows={4}
							placeholder="Ex: Esta é uma mensagem automátca."
							onChange={(e) => setFooterContent(e.target.value)}
							value={footerContent}
						/>
					</DivisionTemplateType>
				</MyModalBody>
			</Modal.Body>
			<Modal.Footer>
				<DefaultButton onClick={handleAPIRegistration}>
					Cadastrar API
				</DefaultButton>
				{!data?.registerByAPI ? <></> : null}
				<DefaultButton onClick={handleTemplateEdit}>Editar</DefaultButton>
			</Modal.Footer>
		</Modal>
	);
}

export { ModalCheckTemplateEdit };
